import type { Field } from '@core/profile-fields-types';
import type { RequisitionStatus } from '@core/requisitions-types';
import type { Task } from '@core/tasks-types';

export type ActivitiesFiltersParams = {
  events: string[];
  offers: number[];
  requisitions?: number[];
  talentPools: number[];
  startDate: string;
  endDate: string;
  page?: number;
  limit?: number;
  timezone?: string;

  cursorPosition?: number | null;
  cursorOrder?: string;
  triggered?: boolean;
  intelligence?: boolean;
};

export type ActivitiesFilterTab =
  | 'offers'
  | 'talentPools'
  | 'date_range'
  | 'events'
  | 'requisitions';

export enum ActivityAuthorKind {
  Admin = 'admin',
  System = 'system',
  SystemIntelligence = 'system_intelligence',
  Referrer = 'referrer',
  Guest = 'guest',
  Candidate = 'candidate',
}

export type TrackingActivity = {
  admin?: { photo_thumb_url: string; name: string; id: number; hasAvatar: boolean };
  attachment?: {
    createdAt: string;
    extension: string;
    fileUrl: string;
    filename: string;
    id: number;
    imageThumbnailUrl?: string;
    imageUrl?: string;
    pdfThumbnailUrl?: string;
    pdfUrl?: string;
    uploader: string;
  };
  avatarUrl: string;
  candidate?: {
    companyId: number;
    id: number;
    name: string;
    offerIds?: number[];
    photoThumbUrl: string;
    referrer: string;
    sourcingOrigin: string;
    isAnonymous?: boolean;
  };
  createdAt: string;
  event: string;
  field?: Field;
  gdprRequest?: {
    message: string;
  };
  id: number;
  import?: { id: number; name: string; sourceId: number | null };
  mailboxMessage?: {
    id: number;
    participants: any;
    private: boolean;
    subject: string;
    text: string;
    threadId: number;
  };
  textingMessage?: {
    id: number;
    text: string;
    from: string;
    to: string;
  };
  message?: { bodyHtml: string; id: number; subject: string };
  messageHtml: string;
  messageShortHtml: string;
  note?: {
    bodyHtml: string;
    id: number;
    noteAssignments: any[];
    private: boolean;
    replyToId: number;
  };
  offer?: {
    title: string;
    slug: string;
    kind: string;
    id: number;
    fromStatus?: string;
    toStatus?: string;
  };
  talentPool?: {
    id: number;
    slug: string;
    title: string;
    toStatus?: string;
  };
  previousField?: Field;
  review?: { body?: string; bodyHtml?: string; id: number; rating: number };
  requisition?: {
    id: number;
    title: string;
    status: RequisitionStatus;
  };
  task?: Task;
  triggered: null | boolean;
  unread?: boolean;
  initials: string;
  hasAvatar: boolean;
  quoteHtml: string;
  authorKind: ActivityAuthorKind;
};
